module.exports = __webpack_public_path__ + "fonts/roboto-blackitalic-webfont.woff2";